import type { FC, ReactElement } from 'react';

import { BackButton } from '@pp/core/src/components/controls/backButton/BackButton';
import { Icon } from '@pp/core/src/components/icons/icon';
import { Icons } from '@pp/core/src/components/icons/iconNames';
import { useAudioTrigger } from '@pp/core/src/controllers/audioController/hooks';

import { useGameDispatch } from '../../../store/GameStore';
import { recentResultDetailStateActions } from '../../../store/slices/recentResultDetail/slice';
import { DateTime } from '../dateTime/DateTime';

import styles from './CloseModal.module.css';

export interface CloseModalProp {
  index: number;
}

export const CloseModal: FC<CloseModalProp> = ({ index }): ReactElement => {
  const dispatch = useGameDispatch();
  const audioTrigger = useAudioTrigger();

  const closeModal = () => {
    audioTrigger.play({ name: 'menuClick' });
    dispatch(recentResultDetailStateActions.setModalOpen(false));
  };

  return (
    <div className={styles.modalUpper}>
      <div className={styles.closeModalDesktop}>
        <button className={styles.closeButton} onClick={closeModal}>
          <Icon icon={Icons.Close} color="white" />
        </button>
      </div>

      <div className={styles.closeModalOther}>
        <div className={styles.backButton}>
          <BackButton visible={true} onClick={closeModal} />
        </div>
        <div className={styles.timeStamp}>
          <DateTime index={index} />
        </div>
        <div></div>
      </div>
    </div>
  );
};
